<template>
  <i v-b-tooltip.hover :title='productType === rawMaterialTypeEko ? "Eko" : "Konwencja"' class="fas fa-leaf pr-2" :class='productType === rawMaterialTypeEko ? "color-green" : "color-red"'></i>
</template>

<script>
import deliveryMixin from '../mixins/delivery'

export default {
  name: "EcoConventionIcon",
  mixins: [deliveryMixin],
  props: ['productType']
};
</script>